/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

interface Props {
  className: any;
  text: string;
  hasDiv: boolean;
  dataText: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const Paragraph = ({ onChange, dataText, className, text = "Type a question", hasDiv = true, disabled = false }: Props): JSX.Element => {
  return (
    <div className={`paragraph ${className}`}>
      <div className="type-a-question-3">{text}</div>
      <textarea className="frame-3" placeholder="請填寫"
        value={dataText}
        onChange={onChange}
        disabled={disabled}
      ></textarea>
      {hasDiv && <div className="text-wrapper-6">Type an error message</div>}
    </div>
  );
};

Paragraph.propTypes = {
  text: PropTypes.string,
  hasDiv: PropTypes.bool,
};
